import { G as GITHUB_API_KEY, a as GITHUB_USER } from "./private.js";
import { Octokit } from "@octokit/rest";
import { d as delay } from "./utils2.js";
import { I as InstallerCollection } from "./firebase.js";
const octokit = new Octokit({
  auth: GITHUB_API_KEY
});
const defaultOptions = {
  owner: GITHUB_USER,
  repo: "glimmr"
};
const getWorkflowJob = async (workflowId) => {
  const jobs = await octokit.rest.actions.listJobsForWorkflowRun({
    ...defaultOptions,
    run_id: workflowId,
    filter: "latest"
  });
  return jobs.data.jobs[0];
};
const waitUntilWorkflowInProgress = async (branch, interval = 1e3 * 5, timeout = 1e3 * 60, start = Date.now()) => {
  console.log("waiting until workflow is in progress", start + timeout - Date.now());
  if (start + timeout < Date.now()) throw new Error("Timeout");
  const email = branch.split("/").pop();
  const installer = await InstallerCollection().doc(email).get();
  const workflows = await octokit.rest.actions.listWorkflowRuns({
    ...defaultOptions,
    branch,
    workflow_id: "main.yml"
  });
  const workflow = workflows.data.workflow_runs[0];
  const isStale = installer?.data()?.cancelled && workflow?.id === installer?.data()?.workflowId;
  if (isStale) {
    await delay(interval);
    return waitUntilWorkflowInProgress(branch, interval, timeout, start);
  } else {
    if (workflow) {
      return workflow;
    }
  }
  await delay(interval);
  return waitUntilWorkflowInProgress(branch, interval, timeout, start);
};
const pollWorkflowJob = async (jobId, onUpdate, waitDuration = 5e3, signal) => {
  if (signal?.aborted) {
    return null;
  }
  const job = await withOptions(octokit.rest.actions.getJobForWorkflowRun, {
    job_id: jobId
  });
  onUpdate(job.data);
  if (job.data.status === "completed") {
    return job.data;
  }
  await delay(waitDuration);
  return pollWorkflowJob(jobId, onUpdate, waitDuration, signal);
};
const triggerWorkflow = (branch, access) => {
  return octokit.rest.actions.createWorkflowDispatch({
    ...defaultOptions,
    workflow_id: "main.yml",
    ref: branch,
    inputs: {
      access
    }
  });
};
const cancelWorkflowRun = async (runId) => {
  try {
    await octokit.rest.actions.cancelWorkflowRun({
      ...defaultOptions,
      run_id: runId
    });
  } catch (err) {
    return null;
  }
};
const withOptions = (fn, params) => fn({
  ...defaultOptions,
  ...params
});
export {
  waitUntilWorkflowInProgress as a,
  cancelWorkflowRun as c,
  getWorkflowJob as g,
  octokit as o,
  pollWorkflowJob as p,
  triggerWorkflow as t,
  withOptions as w
};
